export const METADATA_BOUNDARY_NAME = '__next_metadata_boundary__';
export const VIEWPORT_BOUNDARY_NAME = '__next_viewport_boundary__';
export const OUTLET_BOUNDARY_NAME = '__next_outlet_boundary__';
export const ROOT_LAYOUT_BOUNDARY_NAME = '__next_root_layout_boundary__';

//# sourceMappingURL=boundary-constants.js.map